(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/animations/assets/javascripts/animations/tweens/create-opacity-tween.js') >= 0) return;  svs.modules.push('/components/onboarding/animations/assets/javascripts/animations/tweens/create-opacity-tween.js');
"use strict";



const createOpacityTween = (el, duration) => gsap.to(el, {
  opacity: 0.0,
  duration
});
setGlobal('svs.components.onboarding.animations.tween.createOpacityTween', createOpacityTween);

 })(window);